import { useEffect, useRef } from 'react';
import { useQueryClient } from "@tanstack/react-query";
import { Outlet } from 'react-router-dom';
import { useCode } from '@/hooks/use-code';
import { useShop } from '@/hooks/queries/use-shop';
import { validateSaleStatus } from '@/utils/global-state-validation';
import useCartStore from '@/stores/cart.store';
import { setApiShopCode } from '@/lib/api-client';
import ModalRoot from '@/components/modal/ModalRoot';

export default function ShopLayout() {
  const queryClient = useQueryClient();
  const code = useCode();
  const { data: shop } = useShop(code);
  const clearCart = useCartStore((state) => state.clearCart);
  const previousCode = useRef(code);

  useEffect(() => {
    setApiShopCode(code);

    if (previousCode.current !== code) {
      // Clear all cached queries except the shop query this component just consumed —
      // clearing it too would force an immediate, redundant refetch of data already in hand.
      queryClient.removeQueries({ predicate: (query) => query.queryKey[0] !== 'shops' });
      clearCart();
      previousCode.current = code;
    }
  }, [code])

  // Validate sale status — throws AppError caught by ErrorBoundary
  validateSaleStatus(shop.sale.status);

  return (
    <>
      <Outlet />
      <ModalRoot />
    </>
  );
}
